export default "__VITE_ASSET__DtmhyYqb__"